module.exports = __webpack_public_path__ + "media/application/images/2023/06_still-1600x900-94e95a1bb18db977bd3126347e74e001.png";